import { Stack } from '@mui/material';
import React from 'react';
import { LoadingButton, SibaInput } from '@siba/components';
import { FieldValues, UseFormReturn } from 'react-hook-form';

interface ResetPasswordFormInterface {
    formHandler: UseFormReturn<FieldValues, object>;
    save: (formHandler : UseFormReturn<FieldValues, object>) => any;
}

/**
 * ResetPassword form modal component
 * @param props
 * @returns
 */
const ResetPasswordModalForm: React.FC<ResetPasswordFormInterface> = (props) => {
    const { formHandler, save } = props;
    const {
        register,
        formState: { errors }
    } = formHandler;

    return (
        <div style={{ padding: '30px' }}>
            <Stack direction="column" spacing={2}>
                <div className="form-floating">
                    <SibaInput name="email" label="Email" validationObj={{ required: true }} formHandler={formHandler} type="text" />
                    {/* <input
                        {...register('email', { required: true })}
                        type="email"
                        id="floatingName"
                        className="form-control"
                        placeholder="Enter your email"
                        style={{ border: errors.email ? '1px solid red' : '' }}
                    /> */}
                    {/* <label htmlFor="floatingName">Email</label> */}
                    {/* {errors.name && <span>name is required</span>} */}
                    {/* 
          <LoadingButton
            // className="button-main sign-in-btn"
            id="resetButton"
            onClick={save}
            backgroundColor="primary"
            //style={{width: '100%', height: '46px'}}
            name="Submit"
          />
*/}
                    <LoadingButton className="button-main sign-in-btn w-button" id="resetButton" onClick={()=>save(formHandler)} name="Submit">
                        Submit
                    </LoadingButton>
                    {/* {errors.name && <span>name is required</span>} */}
                </div>
            </Stack>
        </div>
    );
};

export default ResetPasswordModalForm;
